import React from 'react'
import { NavButton } from "./button";
import "./nav.css"

import alex from "../../images/alex.jpg"
import rpi from "../../images/rpi_200.jpg"
import scrabble from "../../images/scrabble.jpg"

const MiscNav = () => {
    return <div id="nav">
        <NavButton link="scrabble" label="scrabble score keeper" image={scrabble} />
        <NavButton link="binary" label="rpi logo binary encoder" image={rpi} />
        <NavButton link="alex" label="alex" image={alex} />
    </div>;
}

export default MiscNav;